export const OUTLOOK_FEATURES = {
  moduleKey: 'outlook',
  features: ['outlook.calendar-sync', 'outlook.email-sync'] as const,
  featureMeta: {
    'outlook.calendar-sync': {
      name: 'Outlook calendar sync',
      translations: {
        name: {
          de: 'Outlook-Kalendersynchronisierung',
          en: 'Outlook calendar sync',
          fr: 'Synchronisation du calendrier Outlook',
          it: 'Sincronizzazione del calendario Outlook',
        },
      },
    },
    'outlook.email-sync': {
      name: 'Outlook email sync',
      translations: {
        name: {
          de: 'Outlook-E-Mail-Synchronisierung',
          en: 'Outlook email sync',
          fr: 'Synchronisation des e-mails Outlook',
          it: 'Sincronizzazione delle e-mail Outlook',
        },
      },
    },
  },
} as const;
